import { createContext, useContext } from 'react';

export const BankContext = createContext();

export const useBankContext = () => useContext(BankContext);
